import { createContext, useContext } from 'react';

/**
 * ההקשר של חלון החרטה. מופרד מהקומפוננטה כדי ש Fast Refresh
 * ימשיך לעבוד: קובץ שמייצא גם קומפוננטה וגם hook מאבד אותו.
 */
export type UndoState = {
  /** מריץ את הפעולה בעוד כמה שניות, ומציג הודעה עם ביטול. */
  remove: (input: { id: string; message: string; perform: () => Promise<unknown> }) => void;
  /** האם הפריט ממתין למחיקה, כדי להסתיר אותו מהרשימה בינתיים. */
  isPending: (id: string) => boolean;
};

export const UndoContext = createContext<UndoState>({
  remove: () => undefined,
  isPending: () => false,
});

export const useUndo = () => useContext(UndoContext);
